import React from 'react'
import { IconButton, Badge } from '@mui/material'
import CameraIcon from '@mui/icons-material/CameraAlt'
import PropTypes from 'prop-types'
import { noop } from 'lodash'

const CameraButton = ({ showBadge, handleCameraClick, disabled, ...restProps }) => (
  <IconButton
    size="small"
    aria-label="camera"
    onClick={handleCameraClick}
    disabled={disabled}
    style={{ padding: '4px' }}
    {...restProps}
  >
    <Badge variant="dot" color="primary" invisible={!showBadge}>
      <CameraIcon />
    </Badge>
  </IconButton>
)

CameraButton.propTypes = {
  showBadge: PropTypes.bool,
  handleCameraClick: PropTypes.func,
  disabled: PropTypes.bool,
}

CameraButton.defaultProps = {
  showBadge: false,
  handleCameraClick: noop,
  disabled: false,
}

export default CameraButton
